<template>
    <div class="search-wrap">
        <!--   搜索     -->
        <!-- <div class="search-box container">
            <div class="search-box-item flex flex-align-center">
                <label>类型</label>
                <div class="type-list">
                    <span v-for="item in searchTypes" :class="[type === item.value && 'checked']" :key="item.value" @click="handleType(item)">{{item.name}}</span>
                </div>
            </div>
            <div class="search-box-item flex flex-align-center">
                <label>字母</label>
                <div class="letters-list">
                    <span v-for="item in searchLetters" :key="item" :class="[letter === item && 'checked']" @click="handleLetter(item)">{{item}}</span>
                </div>
            </div>
        </div> -->
        <!--    内容    -->
        <div class="search-content">
            <ul>
                <li v-for="(item,i) in lists" :key="i"  @click="handleDetail(item)">
                    <img :src="item.cover" alt="封面" srcset="">
                    <p class="line-clamp1">{{item.title}}</p>
                </li>
            </ul>
            <el-pagination
                background
                class="pagination"
                layout="prev, pager, next"
                @current-change="handlePageChange"
                :current-page="page"

                :total="1000">
            </el-pagination>
        </div>
    </div>
</template>

<script setup>
import { reactive, toRefs, onMounted,watch } from "vue";
import { useRouter ,useRoute} from "vue-router/composables";
import { getEbookLists } from '@/api/index.js'
import  useGoDetail from '@/minixs/goDetail';
const router = useRouter()
const route = useRoute()
        const state = reactive({
            searchTypes: [
                {
                    name: '阅读量',
                    value: 0
                },{
                    name: '最新',
                    value: 1
                },{
                    name: '热度',
                    value: 2
                },
            ], // 搜索类型
            searchLetters: ['A','B','C','D','E','F','G','H','I','J','K','L','M',
                'N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
            type: 0,
            letter: 'A',
            lists: [], // 书籍列表
            page: 1

        })
/**类型的点击**/
const handleType =(item)=>{
    state.type = item.value
}
/**字母的点击**/
const handleLetter =(item)=>{
    state.letter = item
}

/**详情页的跳转 使用 mixin 的跳转方法**/
const { handleDetail } = useGoDetail();
/**列表的获取**/
const getLists = async ()=>{
    const query = route.query
    console.log('query:', query)
    const data = { }
    if(query.keyword){  data.title = query.keyword}
    getEbookLists({
        pageNo:state.page,
        pageSize:10,
        ...data
    }).then(({data})=>{
        state.lists = data.list || []
    })
}

/**分页切换**/
const handlePageChange = (page) => {
    console.log('当前页:', page);
    // 这里可以添加获取新数据的逻辑
    state.page = page
    getLists()
}

const {searchTypes,searchLetters,type,letter,lists,page} = toRefs(state)




// 监听$route变化，重新获取列表
watch(() => route.query, () => {
    getLists()
}, { immediate: true })




// 初始化获取列表
onMounted(() => {
    getLists()
})






</script>

<style lang="scss" scoped>
.search-wrap{
    padding: 34px;
}
.search-box{
    &-item{
        margin-bottom: 24px;
        .type-list{

            span{
                padding: 6px 10px;
                margin-right: 20px;
            }
        }
        .letters-list{
           span{
               padding: 1px 5px;
               margin-right: 10px;
           }
        }
        label{
            font-family:Source Han Sans CN;
            color:#2e2e2e;
            font-size:20px;
            margin-right: 41px;
        }

        span{
            color:#2e2e2e;
            font-size:16px;
            cursor: pointer;

            &.checked{
                border-radius: 20px;
                background: #188b97;
                color: #fff;
            }
        }
    }
}
.search-content{
    ul{
        display: grid;
        grid-template-columns: repeat(5, 290px);
        gap: 29px;
        margin: auto;
        justify-content: center;
        li{
            background: #ffffff;
            padding: 17px;
            box-sizing: border-box;
            padding-bottom: 55px;
            cursor: pointer;
               img{
                   width: 257px;
                   height: 340px;
               }
            p{
                color:#2e2e2e;
                font-size:24px;
                margin-top: 15px;
            }

        }
    }
}
.pagination{
    text-align: center;
    margin:30px auto;
}
</style>
